module.exports = __webpack_public_path__ + "media/images/flags/16/Abkhazia-d46023809707c6466b5af8f7b5506bd4.png";